<template>
  <div class="home">
    <menuBox :step="2"></menuBox>
    <div class="main-box ">
      <div class="lsit-box">
        <div class="left-box">
          <div class="title">Game Frontier</div>
          <div class="list-box">
            <div class="list-item">
              <div class="img img-1"></div>
              <div>Collapse of the world</div>
              <p>New sale</p>
            </div>
            <div class="list-item">
              <div class="img img-2"></div>
              <div>Virtual games</div>
              <p>on sale</p>
            </div>
            <div class="list-item">
              <div class="img img-3"></div>
              <div>VR games</div>
              <p>Wearable device required</p>
            </div>
          </div>
        </div>
        <div class="right-box">
          <div class="title">Top Downloaded</div>
          <div class="right-item">
            <img src="../assets/img-8.png" alt="">
            <div class="value">
              <div>Star Wars</div>
              <p>FunFiesta</p>
            </div>
          </div>
          <div class="right-item">
            <img src="../assets/img-9.png" alt="">
            <div class="value">
              <div>VR games</div>
              <p>FunFiesta</p>
            </div>
          </div>
          <div class="right-item">
            <img src="../assets/img-10.png" alt="">
            <div class="value">
              <div>virtual reality</div>
              <p>FunFiesta</p>
            </div>
          </div>
        </div>
      </div>

      <div class="title">About FunFiesta</div>
      <div class="about-box">
        <div class="about-item">
          <img src="../assets/news-4.png" alt="">
          <div>Various mini games</div>
          <p>Gather together to build houses, clear mines and other casual games.</p>
        </div>
        <div class="about-item">
          <img src="../assets/news-5.png" alt="">
          <div>Withdraw cash at any time</div>
          <p>Exchange gold coins for games, no recharge required.</p>
        </div>
        <div class="about-item">
          <img src="../assets/news-6.png" alt="">
          <div>Ranking competition</div>
          <p>Each game has a ranking to challenge players across the server.</p>
        </div>
      </div>

      <div class="title">VR game development</div>
      <div class="vr-list">
        <div class="vr-item">
          <img src="../assets/news-7.png" alt="">
          <div>Immersive experience</div>
          <p>Simulate reality and enhance game immersion.</p>
        </div>
        <div class="vr-item">
          <img src="../assets/news-8.png" alt="">
          <div>Technological innovation</div>
          <p>Continuous technological progress to improve the quality of experience.</p>
        </div>
        <div class="vr-item">
          <img src="../assets/news-9.png" alt="">
          <div>widely used</div>
          <p>Expansion in education, training and other fields.</p>
        </div>
        <div class="vr-item">
          <img src="../assets/news-10.png" alt="">
          <div>market growth</div>
          <p>The user base is expanded and the market potential is huge.</p>
        </div>
      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
};
</script>

<style lang="less" scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main-box {
  width: 1068px;
  min-height: 166px;
  flex-shrink: 0;
  border-radius: 40px;
  opacity: 0.8;
  background: #2F97FF;
  margin-top: 50px;
  padding: 64px 55px;
}

.title {
  color: #FFF;
  font-size: 40px;
  font-weight: 700;
  text-transform: capitalize;
  margin-top: 50px;
}

.lsit-box {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left-box {
    width: 626px;
    height: 402px;
    background-color: #8fbbe7;
    border-radius: 20px;
    padding: 40px;

    .title {
      margin-top: 0px;
    }

    .list-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;

      .list-item {
        width: 192px;

        .img {
          width: 192px;
          height: 275px;
          margin-top: 0px;
          border-radius: 10px;
        }

        .img-1 {
          background: url(../assets/news-1.png) lightgray 50% / cover no-repeat;
        }

        .img-2 {
          background: url(../assets/news-2.png) lightgray 50% / cover no-repeat;
        }

        .img-3 {
          background: url(../assets/news-3.png) lightgray 50% / cover no-repeat;
        }

        div {
          color: #FFF;
          font-size: 18px;
          font-weight: 700;
          margin-top: 20px;
        }

        p {
          color: #FFF;
          font-size: 14px;
          font-weight: 300;
          margin-top: 10px;
        }
      }
    }
  }

  .right-box {
    width: 240px;
    height: 402px;
    background-color: #8fbbe7;
    border-radius: 20px;
    padding: 40px;

    .title {
      margin-top: 0px;
      font-size: 28px;
    }

    .right-item {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      margin-top: 32px;

      img {
        width: 70px;
        margin-right: 10px;
        border-radius: 10px;
      }

      .value {
        color: #FFF;
        font-size: 24px;
        font-weight: 700;

        p {
          font-size: 18px;
          font-weight: 300;
          margin-top: 10px;
        }
      }
    }
  }
}

.about-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;

  .about-item {
    width: 250px;
    height: 211px;
    flex-shrink: 0;
    padding: 40px;
    border: 1px solid #FFF;
    border-radius: 10px;

    img {
      width: 80px;
      height: 80px;
      border-radius: 40px;
    }

    div {
      color: #FFF;
      font-family: Helvetica;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
      margin-top: 24px;
    }

    p {
      color: #FFF;
      font-family: Helvetica;
      font-size: 18px;
      font-style: normal;
      font-weight: 300;
      line-height: normal;
      text-transform: capitalize;
      margin-top: 16px;
    }
  }
}

.vr-list {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 40px;

  .vr-item {
    width: 240px;

    img {
      width: 240px;
      height: 240px;
      border-radius: 5px;
    }

    div {
      color: #FFF;
      font-family: Helvetica;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
      margin-top: 20px;
    }

    p {
      color: #FFF;
      font-family: Helvetica;
      font-size: 18px;
      font-style: normal;
      font-weight: 300;
      line-height: normal;
      text-transform: capitalize;
      margin-top: 8px;
    }
  }
}
</style>
